// extracted by mini-css-extract-plugin
export default {"dropdown":"pagination_dropdown_dropdown__qorQ0","dropdown_select":"pagination_dropdown_dropdown_select__ffDW4"};